import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import {
  fetchBillingProviders,
  fetchRenderingProviders,
  fetchSupervisingProviders,
  clearAllProviders,
} from '../store/providerSlice';

const useProviders = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    billingProviders,
    renderingProviders,
    supervisingProviders,
    loading,
    error,
  } = useSelector((state: RootState) => state.providers);
  const { selectedHospital } = useSelector(
    (state: RootState) => state.hospitals,
  );

  useEffect(() => {
    if (selectedHospital?.tenantId) {
      // Fetch all provider types when component mounts
      dispatch(fetchBillingProviders(selectedHospital.tenantId));
      dispatch(fetchRenderingProviders(selectedHospital.tenantId));
      dispatch(fetchSupervisingProviders(selectedHospital.tenantId));
    } else {
      // Clear all providers if no hospital is selected
      dispatch(clearAllProviders());
    }
  }, [dispatch, selectedHospital?.tenantId]);

  const refetchBillingProviders = () => {
    if (selectedHospital?.tenantId) {
      dispatch(fetchBillingProviders(selectedHospital.tenantId));
    }
  };

  const refetchRenderingProviders = () => {
    if (selectedHospital?.tenantId) {
      dispatch(fetchRenderingProviders(selectedHospital.tenantId));
    }
  };

  const refetchSupervisingProviders = () => {
    if (selectedHospital?.tenantId) {
      dispatch(fetchSupervisingProviders(selectedHospital.tenantId));
    }
  };

  const refetchAllProviders = () => {
    if (selectedHospital?.tenantId) {
      dispatch(fetchBillingProviders(selectedHospital.tenantId));
      dispatch(fetchRenderingProviders(selectedHospital.tenantId));
      dispatch(fetchSupervisingProviders(selectedHospital.tenantId));
    }
  };

  return {
    billingProviders,
    renderingProviders,
    supervisingProviders,
    loading,
    error,
    refetchBillingProviders,
    refetchRenderingProviders,
    refetchSupervisingProviders,
    refetchAllProviders,
  };
};

export default useProviders;
